import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ActionIcon,
    TextInput,
} from '@mantine/core';

export default function DataTableSearch({
    search, onSearch, onSearchClear,
}) {
    return (
        <TextInput
            icon={<FontAwesomeIcon icon="search" />}
            value={search}
            onChange={onSearch}
            placeholder="Поиск по заголовку"
            rightSection={
                search && (
                    <ActionIcon color="red" variant="light" onClick={onSearchClear}>
                        <FontAwesomeIcon icon="times" />
                    </ActionIcon>
                )
            }
        />
    );
}
